module.exports = __webpack_public_path__ + "static/media/lang1.ab7f4d5e.mp3";